/**
 * SkillType enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file SkillType.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum SkillType {
  // Skill defines
  COMPUTER_USE    = 0,
  DEMOLITIONS     = 1,
  STEALTH         = 2,
  AWARENESS       = 3,
  PERSUADE        = 4,
  REPAIR          = 5,
  SECURITY        = 6,
  TREAT_INJURY    = 7,
  MAX_SKILLS      = 8,
}